var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDetailDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-detail-delete_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.475 0 0 4.475 0 10s4.475 10 10 10 10-4.475 10-10S15.525 0 10 0m0 18.333c-4.592 0-8.333-3.741-8.333-8.333S5.408 1.667 10 1.667 18.333 5.408 18.333 10 14.592 18.333 10 18.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.134 6.867a.83.83 0 0 0-1.175 0l-1.95 1.95-1.95-1.95a.83.83 0 1 0-1.175 1.175l1.95 1.95-1.95 1.95a.83.83 0 0 0 .591 1.416.85.85 0 0 0 .592-.241l1.95-1.95 1.95 1.95a.82.82 0 0 0 .592.241.83.83 0 0 0 .592-1.417l-1.95-1.95 1.95-1.95a.83.83 0 0 0 0-1.174z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-detail-delete_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIcDetailDelete;